import useStore from "src/store/store";

export type ClientConfig = {
  bapiURL: string;
  refreshTokenDelay: number; // Milliseconds
  ipapiURL: string;
  refreshInterval: {
    disks: number;
  };
};

export const setClientConfig = (config: ClientConfig) => {
  useStore.setState({ clientConfig: config });
};

export const getClientConfig = () => {
  return useStore.getState().clientConfig;
};
